// *
export const FETCH_ALL = 'fetchAll';

// dashboards
export const FETCH_DASHBOARD = 'fetchDashboard';
export const FETCH_DASHBOARDS = 'fetchDashboards';
export const CREATE_DASHBOARD = 'createDashboard';
export const UPDATE_DASHBOARD = 'updateDashboard';
export const DELETE_DASHBOARD = 'deleteDashboard';

// monitors
export const FETCH_MONITORS = 'fetchMonitors';
export const CREATE_MONITOR = 'createMonitor';
export const UPDATE_MONITOR = 'updateMonitor';
export const ENABLE_MONITOR = 'enableMonitor';
export const DISABLE_MONITOR = 'disableMonitor';
export const DELETE_MONITOR = 'deleteMonitor';

// filters
export const FETCH_FILTERS = 'fetchFilters';
export const CREATE_FILTER = 'createFilter';
export const UPDATE_FILTER = 'updateFilter';
export const DELETE_FILTER = 'deleteFilter';

// settings
export const FETCH_SETTINGS = 'fetchSettings';
export const UPDATE_SETTINGS = 'updateSettings';
export const UPDATE_LEGACY_SETTINGS = 'updateLegacyUserSettings';

// user
export const LOGOUT = 'logout';
export const LOGOUT_OF_ACCOUNT = 'logoutOfAccount';
export const FETCH_USER = 'fetchUser';
export const REGISTER_USER_BY_DETAILS = 'registerUserByDetails';
export const REGISTER_USER_WITH_PASSWORD = 'registerUserWithPassword';
export const LOGIN_WITH_EMAIL = 'loginWithEmail';
export const HINT_USER = 'hintUser';
export const AUTHORISE_WITH_GOOGLE = 'authoriseWithGoogle';
export const AUTHORISE_WITH_XYLEM = 'authoriseWithXylem';
export const REQUEST_PASSWORD_RESET = 'requestPasswordReset';
export const RESET_PASSWORD = 'resetPassword';
export const INVITE_USER = 'inviteUser';
export const VERIFY_USER = 'verifyUser';
export const RESEND_VERIFICATION_EMAIL = 'resendVerificationEmail';

// users
export const FETCH_USERS = 'fetchUsers';
export const REVOKE_USER = 'revokeUser';
export const UPDATE_USER_ROLE = 'updateUserRole';
export const REVOKE_INVITE = 'revokeInvite';
export const CREATE_USER = 'createUser';

// widget
export const UPDATE_WIDGET = 'updatedWidget';

// role
export const ACCEPT_INVITES = 'acceptInvites';
export const FETCH_ACCOUNTS = 'fetchAccounts';
export const ADD_ACCOUNT = 'addAccount';
export const RENAME_ACCOUNT = 'renameAccount';
export const SET_LEGACY_ACCOUNT = 'setLegacyAccount';
export const SUDO_SET_ACCOUNT = 'sudoSetAccount';
export const RESTORE_ACCOUNT = 'restoreAccount';

// account
export const FETCH_ACCOUNT = 'fetchAccount';

// kpis
export const FETCH_KPIS = 'fetchKpis';
export const UPDATE_KPI = 'updateKpi';
export const DELETE_KPI = 'deleteKpi';

// View
export const VIEW_SET_PIVOT_PROPERTY = 'viewSetPivotProperty';
export const VIEW_SET_FILTER = 'viewSetFilter';
export const VIEW_SELECT_PANE = 'selectPane';
export const VIEW_DESELECT_PANE = 'deselectPane';
export const VIEW_CHANGE_SELECTION = 'viewChangeSelection';
export const VIEW_CHANGE_TIME_PERIOD = 'viewChangeTimePeriod';
export const VIEW_CHANGE_TIME_RANGE = 'viewChangeTimeRange';
export const VIEW_UPDATE_CURRENT_TIME = 'viewUpdateCurrentTime';
export const VIEW_CHANGE_REFRESH_TIME = 'changeRefreshTime';

// Integrations
export const FETCH_INTEGRATIONS = 'fetchIntegrations';
export const CREATE_WEBHOOK = 'createWebhook';
export const UPDATE_WEBHOOK = 'updateWebhook';
export const REMOVE_WEBHOOK = 'removeWebhook';

// UI
export const FETCH_UI_METADATA = 'fetchUIMetadata';
